import { SiNextdoor } from "react-icons/si";
import { FaFacebook } from "react-icons/fa";

export default function Footer(){
    const year = new Date().getFullYear()
    
    return(
        <div className="footer">
            <div className="footer-stuff body-text">
                <div className="social-icons">
                    <a href="https://www.facebook.com/groups/1083004331754635">
                        <FaFacebook/>
                    </a>
                    <a 
                        href="https://nextdoor.com/neighborhood/ridgewoodcivic--cincinnati--oh/" className="next-door"   
                    >
                        <SiNextdoor size={84}/> 
                    </a>
                </div>
                <p>&#169; {year} Ridgewood Civic</p>
            </div>
        </div>     
)
}